export const API_STATUS = "API_STATUS";
export const FETCH_ROWS = "FETCH_ROWS";
export const FETCH_DROPDOWN = "FETCH_DROPDOWN";
export const TOGGLE_DEF_POPUP = "TOGGLE_DEF_POPUP";
export const SET_OPEN_DATA = "SET_OPEN_DATA";
export const SET_CHILD_DATA = "SET_CHILD_DATA";
export const EDIT_PROCESS_DATA = "EDIT_PROCESS_DATA";
